<script>
  export let notification;
  export let getNotifications;

  import ActionModal from "../utils/ActionModal.svelte";
  import { resendNotification, deleteNotification } from "../api";
  import { notificationsList, alert } from "../store";
  import to from "await-to-js";

  function showDateTime(dateTime) {
    return new Date(dateTime).toLocaleDateString();
  }

  const { data = {}, statistics = {}, wrapper_id, created_at } = notification;
  const { recipient_count, delivered, clicked } = statistics;
  const { title, content, image } = data;

  $: modal = {
    show: false,
    title: "",
    message: "",
    func: () => {}
  };

  async function onDelete() {
    modal.show = false;

    const [error, _] = await to(deleteNotification(wrapper_id));

    if (error) return;

    alert.setWithTimeout({
      value: "Notification deleted successfully",
      className: "is-success"
    });

    notificationsList.update(
      l => (l = [...l.filter(i => i.wrapper_id !== wrapper_id)])
    );
  }

  async function onResend() {
    modal.show = false;

    const [error, _] = await to(resendNotification(wrapper_id));

    if (error) return;

    alert.setWithTimeout({
      value: "Notification resent successfully",
      className: "is-success"
    });

    getNotifications(0);
  }
</script>

<style>
  .image {
    height: 50px;
  }
  td {
    vertical-align: middle;
  }

  .mtitle {
    width: 10%;
  }
  .content {
    width: 20%;
  }
</style>

<tr>
  <td class="mtitle">
    <p>{title}</p>
  </td>
  <td class="content">
    <p>{content}</p>
  </td>
  <td>
    {#if Boolean(image)}
      <img class="image" src={image} alt="Notification Image" />
    {/if}
  </td>
  <td>
    <p>{showDateTime(created_at)}</p>
  </td>
  <td>
    <p>{recipient_count}</p>
  </td>
  <td>
    <p>{delivered}</p>
  </td>
  <td>
    <p>{clicked}</p>
  </td>

  <td>
    <button
      class="button is-success is-light"
      on:click={() => {
        modal.message = `Are you sure you want to resend the notification?`;
        modal.title = `confirm resending`;
        modal.func = onResend;
        modal.show = true;
      }}>
      <li class="fas fa-redo" />
    </button>

    <button
      class="button is-danger is-light"
      on:click={() => {
        modal.message = `Are you sure you want to delete the notification?`;
        modal.title = `confirm deletion`;
        modal.func = onDelete;
        modal.show = true;
      }}>
      <li class="fas fa-trash" />
    </button>
  </td>

  <ActionModal
    show={modal.show}
    onAccept={() => modal.func()}
    onDiscard={() => (modal.show = false)}
    title={modal.title}
    message={modal.message} />
</tr>
